<template>
<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M8 14.5V13.0833L11.5333 9.55L12.95 10.9667L9.41667 14.5H8ZM2 11.1667V9.83333H6.66667V11.1667H2ZM13.4167 10.5L12 9.08333L12.4833 8.6C12.6056 8.47778 12.7611 8.41667 12.95 8.41667C13.1389 8.41667 13.2944 8.47778 13.4167 8.6L13.9 9.08333C14.0222 9.20556 14.0833 9.36111 14.0833 9.55C14.0833 9.73889 14.0222 9.89444 13.9 10.0167L13.4167 10.5ZM2 8.5V7.16667H9.33333V8.5H2ZM2 5.83333V4.5H9.33333V5.83333H2Z"
      fill="#495A6B"/>
</svg>
</template>
